<template>
    <div class="c-algolia-search__form c-algolia-search__form--mini">
        <div class="c-algolia-search__field c-algolia-search__field--keywords">
            <label class="c-algolia-search__label" for="keywords">Search</label>
            <div class="c-algolia-search__input-wrapper">
                <input
                    v-model="searchText"
                    type="text"
                    placeholder="Keywords"
                    v-on:keyup.enter="triggerSearchGuidelines"
                />
                <button class="c-algolia-search__button" @click="triggerSearchGuidelines"></button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";

export default {
    name: 'AnzcorSearchField',
    props: {
        searchPage: {
            type: String,
            required: true
        }
    },
    computed: {
        ...mapFields([
            "searchApp.search.searchText",
        ]),
    },
    methods: {
        triggerSearchGuidelines() {
            const params = new URLSearchParams({
                selectedCategories: 'all',
                sort: '',
                searchText: this.searchText,
                start: 0
            });

            if (window.location.origin.includes("localhost")) {
                // add param
                params.append('SubsiteID', '1');
            }

            window.location.href = `${this.searchPage}?${params.toString()}`;
        },
    },
};
</script>